export enum EmailSettingsTypes {
    GET_EMAIL_CONFIGS = 'GET_EMAIL_CONFIGS',
    GET_EMAIL_CONFIGS_LOADING = 'GET_EMAIL_CONFIGS_LOADING',
}

export interface IEmailConfig {
    autoReplyTemplateID: string;
    ccAutoReplyTemplateID?: string;
    outboundTemplateID: string;
    businessEmail: string;
    contactFlowID: string;
    queueARN: string;
    queueName: string;
    enableAutoReply: boolean;
    agentHierarchy?: string;
    brand: string;
    allowAgentInitiatedEmail: boolean;
    saEmailAddress: string;
    customAttributes?: Record<string, string>;
    allowedRoutingProfiles?: string[];
    virusScanEnabled?: boolean;
}

export interface IEmailTemplate {
    ID: string
    htmlTemplate: string
    subject: string
    templateData: Record<string, string>
    textTemplate: string
}

interface IEmailConfigUpdateBody {
    autoReplyTemplateID?: string;
    outboundTemplateID?: string;
    queueARN?: string;
    enableAutoReply?: boolean;
    brand?: string;
    customAttributes?: Record<string, string> | null;
    queueName?: string;
    allowedRoutingProfiles?: string[];
    allowAgentInitiatedEmail?: boolean;
    virusScanEnabled?: boolean;
}

export interface IEmailConfigUpdateData {
    email: string;
    data: IEmailConfigUpdateBody;
}
